/**
 * The in-house administrator — members and groups CBS administers itself, as opposed
 * to one of a tenant's external TPAs.
 *
 * Shared rather than written at each use because the code is a wire value: the group
 * search accepts it as the inverse of an external-TPA filter ("CBS groups only"), so
 * the client and the router have to agree on the exact string. Every other
 * administrator in a filter list comes from the tenant's registered adapter; this one
 * has no adapter, because it is the absence of an external administrator.
 */
export const IN_HOUSE_ADMINISTRATOR = {code: 'CBS', label: 'CBS'} as const;
